import { Input } from "@progress/kendo-react-inputs";

import { ICON_BASE_PATH } from "../../utils/config";
import { memo } from "react";

interface SearchInputProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  placeholder?: string;
  bg?: boolean;
}

const DrawerSearchInput: React.FC<SearchInputProps> = memo(
  ({ searchQuery, onSearchChange, placeholder, bg }) => {
    return (
      <div className="relative gx_drawersearch rounded-xl bg-[#F5F5F5]! gx-font-medium">
        <Input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(String(e.target.value))}
          placeholder={placeholder}
          className={`gx-font-medium ${bg === false ? "bg-[#ffffff]! border!! border-[#F5F5F5]! border-[2px]!" : "bg-[#F5F5F5]!"} `}
        />
        <img src={`${ICON_BASE_PATH}search.svg`} alt="arrown" />
      </div>
    );
  },
);

export default DrawerSearchInput;
